module.exports = __webpack_public_path__ + "media/LandingPageAssets/mediumIcon-13c4c066.svg";